import { environment } from '@bd-env/environment';

export const urls = {
  // Frontend config
  getFrontendConfig: () => `${environment.apiUrl}/api/v1/FrontendConfig`
};
